import { environment } from './../../../../../environments/environment.prod';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  baseURL = environment.baseURL;
  tabs: any[] = [];
  constructor(private http: HttpClient) {
    this.tabs.push({
      id: 0,
      header: "",
      type: "Deliveribility Report - ",
      isClosable: false
    });
  }

  getDomainData(body: any) {
    const todayDate = moment().format('YYYY-MM-DD')
    if(body?.start_date === todayDate && body?.end_date === todayDate)
    {
      return this.http.post(this.baseURL + "ongageReport/liveDeliveryReport", body);
    }
    else
    {
      return this.http.post(this.baseURL + "ongageReport/delivery_report", body);
    }

  }

}
